module.exports = __webpack_public_path__ + "static/media/face5b.fda092e2.jpg";